<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-03-19 15:28:54
-->
<template>
  <el-dialog @close="close" :visible="visible" :close-on-click-modal="false" width="600px" center append-to-body>
    <div class="login-title">
      <div class="title">{{$hs('登录','Sign In','Iniciar sesión')}}</div>
    </div>
    <div class="form-box">
      <el-form :model="form" ref="form" label-width="160px" :rules="rules">
        <el-form-item prop="userAccount" :label="$hs('用户名','User Name','Nombre de usuario') + ':'" required>
          <el-input v-model="form.userAccount" @keyup.enter.native="loginFun"></el-input>
        </el-form-item>
        <el-form-item prop="userPassword" :label="$t('LLH.password') + ':'" required>
          <el-input type="password" v-model="form.userPassword" @keyup.enter.native="loginFun"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loginFun" class="btn">{{ $hs('登录','Login','Iniciar sesión') }}</el-button>
      </span>
      <div class="operation">
        <div>
          {{ $hs('没有账号','New Customer','Nuevo cliente') }}?
          <span
            style="cursor: pointer;color:red;"
            @click="register"
          >{{ $hs('立即注册','Start Here.','Empieza aquí.') }}</span>
        </div>
        <div style="color: #909399;cursor: pointer;" @click="forgetpassword">{{ $hs('忘记密码','Forget Password','Olvidar la contraseña') }}</div>
      </div>
    </div>
    <reset-pass-model ref="resetPassModel"></reset-pass-model>
  </el-dialog>
</template>
<script>
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import { mapActions, mapState } from 'vuex'
import { LoginMemberNoCode, LoginMemberByEmailNoValideCode } from '@/api/login'
export default {
  name: 'loginModal',
  components: {
    resetPassModel
  },
  data() {
    return {
      visible: false,
      codeData: {},
      form: {
        userAccount: '',
        userPassword: '',
        isAudit: false
      },
      rules: {}
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    resetPass() {
      this.$refs.resetPassModel.open()
    },
    register() {
      this.close()
      this.$emit('register')
    },
    forgetpassword() {
      this.close()
      this.$emit('forgetpassword')
    },
    // 登录
    loginFun() {
      let _this = this
      this.$refs.form.validate(values => {
        if (!values) return false
        LoginMemberNoCode(this.form)
          .then(res => {
            if (res.success) {
              _this.set_userInfo(res.data)
              _this.$message.success(
                _this.$hs(
                  '登录成功',
                  'Login succeeded',
                  'Inicio de sesión exitoso'
                )
              )
              _this.close()
              // _this.$router.push('/home')
              window.location.reload() // 强刷界面
            }
          })
          .catch(err => {
            if (err.includes('D1632') || err.includes('D1631')) {
              _this.$message.error(_this.$t('CodeError'))
            } else if (err.includes('D1629')) {
              _this.$message.error(_this.$t('notreviewed'))
            } else if (err.includes('D1628')) {
              _this.$message.error(_this.$t('loginError'))
            }
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .login-title {
    height: 64px;
    border-bottom: 1px solid #eee;

    .title {
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-size: 24px;
      color: #ffffff;
      background: #490d59;
    }
    .msg {
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
  }

  .form-box {
    padding: 20px;
  }

  .operation {
    padding: 0 40px 30px;
    font-size: 14px;
    color: #222222;
    display: flex;
    justify-content: space-between;
  }
}
:deep .el-form {
  padding: 0 40px 0 0;
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  padding: 20px 40px 0;
  box-sizing: border-box;
  .btn {
    flex: 1;
    margin-bottom: 10px;
    background-color: #490d59;
    border-color: #490d59;
  }
}

:deep(.el-form-item__error) {
  display: none;
}
</style>